import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { SubMenuItemsType } from "@/types/menu";

export const FeatureIconItem = ({ items }: { items: SubMenuItemsType }) => {
  if (!items?.items || items.items.length === 0) return null;

  return (
    <div className="flex flex-1 gap-4 h-full">
      {items.items.map((item, index) => (
        <NavigationMenuLink asChild key={index} className="rounded-md">
          <a 
            className="rounded-md shadow-lg p-px bg-image-gradient-primary transform transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            href={item?.link || "/"}
          >
            <div className="flex flex-col justify-between bg-white dark:bg-gray-950 p-4 h-full rounded-[calc(0.5rem-1px)]">
              {item?.hasIcon && item?.icon && (
                <div className="w-12 h-12 flex items-center justify-center shrink-0">
                  <span className="material-symbols-outlined w-12 h-12 text-gradient-primary size-12 !text-5xl/12">
                    {item?.icon}
                  </span>
                </div>
              )}
              <div className="flex flex-col">
                {item?.title && (
                  <h6>{item?.title}</h6>
                )}
                {item?.subtitle && (
                  <p className="paragraph-sm text-muted-foreground">
                    {item?.subtitle}
                  </p>
                )}
              </div>
            </div>
          </a>
        </NavigationMenuLink>
      ))} 
    </div>
  );
}; 

FeatureIconItem.displayName = 'NavFeatureIconItem'; 